'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017, IOOF Holdings Limited.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

var flattenReducers = function flattenReducers(reducers, parentKey) {
  if (typeof reducers === 'function') {
    return _defineProperty({}, parentKey.replace(/\//g, '.'), reducers);
  }

  return Object.keys(reducers).reduce(function (reducerMap, key) {
    return _extends({}, reducerMap, flattenReducers(reducers[key], parentKey ? parentKey + '.' + key : key));
  }, {});
};

exports.default = flattenReducers;